// Registry of pages and the "targets" that can receive a texture highlight.
// Targets are either paragraphs (kind: "text") or card surfaces (kind: "card").
// Add pages/targets here and they show up in Admin → Config, consumable via
// <HighlightedText/> (text) or per-component card wiring.

export const HIGHLIGHT_PAGES = [
  {
    id: "home",
    label: "Home Page",
    targets: [
      { id: "hero_intro", kind: "text", label: "Hero intro paragraph", sample: "Enter your NEET All India Rank to discover colleges…" },
      { id: "coverage_line", kind: "text", label: "Coverage stat line", sample: "1,078 colleges mapped across 34 states & UTs" },
      { id: "cta_paragraph", kind: "text", label: "CTA section paragraph", sample: "Our platform aggregates counselling data from MCC…" },
      { id: "step_rank", kind: "card", label: "Enter Your Rank", sample: "How-it-works step 1 card" },
      { id: "step_filters", kind: "card", label: "Apply Filters", sample: "How-it-works step 2 card" },
      { id: "step_predictions", kind: "card", label: "View Predictions", sample: "How-it-works step 3 card" },
    ],
  },
  {
    id: "predictor",
    label: "Predictor Page",
    targets: [
      { id: "college_card", kind: "card", label: "College result card", sample: "Applied to every prediction card" },
    ],
  },
];

// Returns { texture_id } when a target is active (page enabled + texture set), else null.
export function getHighlight(pageHighlights, pageId, targetId) {
  const page = pageHighlights?.[pageId];
  if (!page?.enabled) return null;
  const t = page.targets?.[targetId];
  if (!t?.texture_id) return null;
  return { texture_id: t.texture_id };
}
